/**
 * Mongolian tögrög.
 */
export var MNT = {
  code: 'MNT',
  base: 10,
  exponent: 2
};